"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const TextInput = (props) => {
    const { label, value = "", disabled = false, type = "string", onChangeValue = undefined, error, placeholder } = props;
    const onChange = (event) => {
        switch (type) {
            case "string":
                onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(event.target.value);
                break;
            case "integer":
                onChangeValue && (0, helper_1.integerFieldHandler)(event.target.value, onChangeValue);
                break;
            case "positiveNumber":
                onChangeValue && (0, helper_1.positiveFieldHandler)(event.target.value, onChangeValue);
                break;
        }
    };
    return (react_1.default.createElement("label", { className: "c-text-input-label" },
        react_1.default.createElement("div", null, label),
        react_1.default.createElement("input", { className: "c-text-input", disabled: disabled, value: value, onChange: onChange, placeholder: placeholder }),
        react_1.default.createElement("div", { className: "c-text-input-error" }, error)));
};
exports.TextInput = TextInput;
